import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { Card, CardContent } from './ui/card';
import { Play, Tv, ExternalLink } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const FeaturedVideo = ({ className = '' }) => {
  const [video, setVideo] = useState(null);
  const [playing, setPlaying] = useState(false);

  useEffect(() => {
    axios.get(`${API}/youtube/videos/latest?limit=1`)
      .then(res => {
        if (res.data && res.data.length > 0) setVideo(res.data[0]);
      })
      .catch(() => {});
  }, []);

  if (!video) return null;

  return (
    <Card className={`overflow-hidden ${className}`} data-testid="featured-video">
      <div className="relative">
        {playing ? (
          <div className="aspect-video">
            <iframe
              src={`${video.embed_url}?autoplay=1&rel=0`}
              title={video.title}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              className="w-full h-full"
            />
          </div>
        ) : (
          <div
            className="aspect-video relative cursor-pointer group"
            onClick={() => setPlaying(true)}
          >
            <img
              src={video.thumbnail_url.replace('mqdefault', 'hqdefault')}
              alt={video.title}
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-black/20 group-hover:bg-black/40 transition-all flex items-center justify-center">
              <div className="w-16 h-16 rounded-full bg-red-600/90 flex items-center justify-center group-hover:scale-110 transition-transform">
                <Play className="w-8 h-8 text-white fill-white ml-1" />
              </div>
            </div>
          </div>
        )}
      </div>
      <CardContent className="p-4">
        <h3 className="font-medium text-sm leading-tight line-clamp-2">{video.title}</h3>
        <div className="flex items-center justify-between mt-2">
          <span className="text-xs text-muted-foreground flex items-center gap-1">
            <Tv className="w-3 h-3" />
            {video.channel_name}
          </span>
          <Link
            to="/videos"
            className="text-xs text-primary hover:underline flex items-center gap-1"
          >
            More videos <ExternalLink className="w-3 h-3" />
          </Link>
        </div>
      </CardContent>
    </Card>
  );
};

export default FeaturedVideo;
